import { render, staticRenderFns } from "./exhibitionDetail.vue?vue&type=template&id=38e5362c&scoped=true"
import script from "./exhibitionDetail.vue?vue&type=script&lang=js"
export * from "./exhibitionDetail.vue?vue&type=script&lang=js"
import style0 from "./exhibitionDetail.vue?vue&type=style&index=0&id=38e5362c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e5362c",
  null
  
)

export default component.exports